import { useSelector } from '@xstate/react';
import { ActorRefFrom } from 'xstate';
import { EmployerInfoForm, type EmployerInfoValues } from '~/features/employer/components';
import { Container, Footer, FormContent, Header } from './components/Layout';
import { employerRegistrationView } from './registration-view.machine';

interface Props {
  actorRef: ActorRefFrom<typeof employerRegistrationView>;
  loading?: boolean;
}

export const RegistrationEmployerInfoForm = ({ actorRef, loading }: Props) => {
  // [MCV-1667] The machine keeps context.employerInfo after
  // ON_SUBMIT_EMPLOYER_INFO, but the form remounts on Back with no defaults
  // -- read it back so the fields are restored instead of blank.
  const employerInfo = useSelector(actorRef, (state) => state.context.employerInfo);

  const handleSubmit = (data: EmployerInfoValues) => {
    actorRef.send({ type: 'ON_SUBMIT_EMPLOYER_INFO', data });
  };

  const handleBack = () => {
    actorRef.send({ type: 'ON_PREVIOUS_PAGE' });
  };

  return (
    <Container>
      <Header
        title="Organization details"
        subtitle="Please provide the following information about your organization to complete your registration."
      />

      <FormContent>
        <EmployerInfoForm defaultValues={employerInfo} onSubmit={handleSubmit} loading={loading} />
      </FormContent>

      <Footer handleBack={handleBack} loadingPercent={35} />
    </Container>
  );
};
